<script>
  import { IconButton } from '../Button';
  import { useTray } from './TrayBase.svelte';

  const tray = useTray();
</script>

<IconButton icon='close' on:click={() => tray.dismiss()}/>
